import { getCookie } from '@/utils/cookies'

export const baseQueryConfig: any = {
  credentials: 'include',
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  prepareHeaders: (headers: Headers) => {
    headers.append('X-CSRFToken', getCookie('csrftoken'))
    if (localStorage.getItem('jwt')) {
      // Adding JWT header only when available, so E2E tests don't break.
      // We can remove this when we migrate E2E to use JWT
      headers.append('Authorization', `JWT ${localStorage.getItem('jwt')}`)
    }
    return headers
  },
}
